import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { ChipModule } from 'primeng/chip';
import { DropdownModule } from 'primeng/dropdown';
import { PanelModule } from 'primeng/panel';
import { COMMON_IMPORTS } from '../../common-imports';
import { TranslatePipe } from '../../languages/translate.pipe';
import Mustache from 'mustache';

@Component({
  selector: 'app-myopia-progression-eim-retest',
  standalone: true,
  imports: [...COMMON_IMPORTS, PanelModule, DropdownModule, ChartModule, ChipModule],
  templateUrl: './myopia-progression-eim-retest.component.html',
  styleUrl: './myopia-progression-eim-retest.component.css',
})
export class MyopiaProgressionEimRetestComponent implements OnInit, OnChanges {
  @Input({ required: true })
  retestMonths: number = 0;

  public retestLabel: string = 'NONE';
  public eimLabel: string = 'NONE';
  public eimManagementOptions: string = 'NONE';

  constructor(private translatePipe: TranslatePipe) {}

  ngOnInit(): void {
    this.refreshAll();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.refreshAll();
  }

  private refreshAll(): void {
    this.eimLabel = this.translatePipe.transform('MYOPIA_PROGRESSION_EIM_IDENTIFIED');

    let LENGTH = this.retestMonths;
    let LENGTH_SUFFIX = this.translatePipe.transform('MONTHS');

    if (this.retestMonths == 12) {
      LENGTH = this.retestMonths / 12;
      LENGTH_SUFFIX = this.translatePipe.transform('YEAR');
    } else if (this.retestMonths == 24) {
      LENGTH = this.retestMonths / 12;
      LENGTH_SUFFIX = this.translatePipe.transform('YEARS');
    } else {
      LENGTH = this.retestMonths;
      LENGTH_SUFFIX = this.translatePipe.transform('MONTHS');
    }

    const eimManagementTemplate = this.translatePipe.transform('MYOPIA_PROGRESSION_EIM_OPTIONS_TEMPLATE');
    this.eimManagementOptions = Mustache.render(eimManagementTemplate, { LENGTH, LENGTH_SUFFIX });

    const eimRetestTemplate = this.translatePipe.transform('MYOPIA_PROGRESSION_EIM_RETEST_TEMPLATE');
    this.retestLabel = Mustache.render(eimRetestTemplate, { LENGTH, LENGTH_SUFFIX });
  }
}
